import React from "react";
import { Link } from "react-router-dom";
import PublicSiteShell from "../components/PublicSiteShell";
import SEOHead from "../components/SEOHead";
import { LANDING_PAGES } from "../data/seoLandingPages";

export default function SeoGuidesHubPage() {
  return (
    <PublicSiteShell>
      <SEOHead
        title="Ibadan Rent Guides | LiteRent"
        description="Explore LiteRent guides for rent in Ibadan, apartments, bedroom options, and key areas like Akobo, Bodija, and Jericho."
        canonical="https://literent.com.ng/ibadan-rent-guides"
      />

      <section className="bg-gradient-to-br from-[#294c79] via-[#2f5588] to-[#1f3a5c] text-white px-6 py-16 sm:py-20">
        <div className="max-w-6xl mx-auto text-center">
          <span className="inline-flex rounded-full bg-white/10 border border-white/15 px-4 py-2 text-xs font-semibold uppercase tracking-[0.22em]">Ibadan rent guides</span>
          <h1 className="mt-5 text-4xl sm:text-5xl font-bold leading-tight">Find the right LiteRent path for the kind of home you want</h1>
          <p className="mt-5 text-lg text-white/80 max-w-3xl mx-auto leading-relaxed">Whether you are searching by area, budget, or bedroom size, these LiteRent guides help you explore homes in Ibadan without losing the main promise: verified homes, clearer information, and a more manageable move-in path for eligible renters.</p>
          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <Link to="/browse" className="rounded-full bg-[#a5c250] px-7 py-3.5 font-semibold text-white hover:bg-[#8bb83a] transition">Browse homes</Link>
            <Link to="/how-it-works" className="rounded-full border border-white/30 px-7 py-3.5 font-semibold hover:bg-white/10 transition">See how LiteRent works</Link>
          </div>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 py-14">
        <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-6">
          {LANDING_PAGES.map((page) => (
            <Link
              key={page.slug}
              to={`/${page.slug}`}
              className="group rounded-[1.75rem] border border-[#e8f2d1] bg-white p-6 shadow-[0_16px_50px_rgba(41,76,121,0.08)] hover:-translate-y-1 transition"
            >
              <div className="inline-flex rounded-full bg-[#f5f9ec] px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-[#294c79]">{page.heroTag}</div>
              <h2 className="mt-4 text-2xl font-bold text-[#294c79] leading-snug group-hover:text-[#1f3a5c]">{page.heading}</h2>
              <p className="mt-3 text-[#1a1a1a]/70 leading-7 text-sm">{page.description}</p>
              <div className="mt-5 inline-flex items-center gap-2 rounded-full bg-[#294c79] px-4 py-2 text-sm font-semibold text-white">Open guide <span aria-hidden="true">→</span></div>
            </Link>
          ))}
        </div>
      </section>
    </PublicSiteShell>
  );
}
